import {
  Button,
  Collapse,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Table,
} from "antd";
import { api } from "../../../../config";
import "./style.css";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../../interfaces/users";
import { toast } from "react-toastify";
import dayjs, { Dayjs } from "dayjs";
import duration from "dayjs/plugin/duration";
import { hasMinimumPermissions } from "../../../../utils/helpers/userHelpers";
import {
  PaymentAdditionStatusEnum,
  PaymentAdditionsViewModel,
  TicketViewModel,
} from "../../../../interfaces";
import { useQuery } from "react-query";
import { Excel } from "antd-table-saveas-excel";
import { getProductsAssembleTime } from "../../../../utils/helpers/ticketHelpers";
import { capitalizeWords, truncateString } from "../../../../utils";
import { DeleteOutlined } from "@ant-design/icons";
import { PaymentAdditionsType } from "../../../../interfaces/paymentAdditionsType";
import { format } from "date-fns";
import { AddonsForm } from "../../../Shared/Addons/AddonsForm";

dayjs.extend(duration);

interface ApprovementProps {
  id: number;
  refetch?: any;
  ticket?: TicketViewModel;
}

type FieldType = {
  description?: string;
  value?: number;
};

export const Approvement: React.FC<ApprovementProps> = ({ id, refetch, ticket }) => {
  const { token, user } = useSelector((state: AuthenticationState) => state);
  const { refetch: boardRefetch } = useQuery({
    queryKey: `tickets/assemble/board`,
  });
  // const { data: additionalTypes, isFetching: isFetchingAdditionalTypes } =
  //   useQuery<PaymentAdditionsType[]>("payment-additional-types", () =>
  //     api(token).get(`payment/additions/types`)
  //   );

  const [additionals, setAdditionals] = useState<{
    [key: number]: PaymentAdditionsViewModel[];
  }>({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [allTickets, setAllTickets] = useState<any[]>([ticket]);
  const [paymentMethod, setPaymentMethod] = useState<"individual" | "mass">(
    "individual"
  );
  const [period, setPeriod] = useState<{
    initial?: string;
    final?: string;
  }>({ initial: undefined, final: undefined });
  const [loading, setLoading] = useState(false);

  const onAddonCreationRefetch = () => {
    boardRefetch();
    refetchAdditions();
  };
  const getTotalValue = (ticketId?: number) => {
    let total = 0;
    if (ticketId) {
      total =
        additionals[ticketId]
          ?.filter((additional) => additional.status === ("APPROVED" as any))
          ?.reduce((a: any, b: any) => a + Number(b.value), 0) || 0;

      const ticket = allTickets.find((t: any) => t.id === ticketId);
      if (ticket) {
        total += ticket?.products.reduce(
          (a: any, b: any) => a + Number(b.value),
          0
        );
      }
    } else {
      total +=
        Object.values(additionals)
          .flat()
          .filter((additional) => additional.status === ("APPROVED" as any))
          .reduce((a: any, b: any) => a + Number(b.value), 0) || 0;

      total += allTickets.reduce(
        (a: any, b: any) =>
          a + b?.products.reduce((a: any, b: any) => a + Number(b.value), 0),
        0
      );
    }

    return total;
  };

  const exportXls = async () => {
    if (allTickets.length === 0) return;

    const excel = new Excel();
    const dateFormated = dayjs().format("DD-MM-YYYY");
    const assemblerName = ticket?.owner?.fullName;
    const dataSource: any[] = [];

    let totalValue = 0;
    allTickets.forEach((item: any) => {
      let value = item?.products.reduce(
        (a: any, b: any) => a + Number(b.value),
        0
      );

      dataSource.push({
        title: item.title,
        eventDate: item.EventsAssemble?.[0]?.start
          ? dayjs(new Date(item.EventsAssemble?.[0]?.start)).format(
              "DD-MM-YYYY"
            )
          : "N/A",
        assembler: item.owner?.fullName,
        assemblyTime: getProductsAssembleTime(item.products) + " Horas",
        value: `R$ ${value.toFixed(2)}`,
        pago: "",
      });
      totalValue += value;
      const additional = additionals[item.id];
      additional.forEach((additional: any) => {
        if (additional.status !== "APPROVED") return;
        dataSource.push({
          title: `${item.title.split(" | ")[0]} - ${additional.type}`,
          assembler: ticket?.owner?.fullName,
          assemblyTime: "ADICIONAL",
          value: `R$ ${additional.value.toFixed(2)}`,
          pago: "",
        });
        totalValue += additional.value;
      });

      dataSource.push({
        title: `Total do Período`,
        eventDate: "",
        assembler: "",
        assemblyTime: "TOTAL",
        value: `R$ ${totalValue.toFixed(2)}`,
        pago: "",
      });
    });

    excel
      .addSheet("Pagamentos")
      .addColumns([
        {
          title: "Ticket",
          dataIndex: "title",
        },
        {
          title: "Data",
          dataIndex: "eventDate",
        },

        {
          title: "Montador",
          dataIndex: "assembler",
        },
        {
          title: "Horas",
          dataIndex: "assemblyTime",
        },
        {
          title: "Valor",
          dataIndex: "value",
        },
        {
          title: "Pago?",
          dataIndex: "pago",
        },
      ])
      .addDataSource(dataSource)
      .saveAs(`Pagamento_${assemblerName}_${dateFormated}.xlsx`);
    toast.success("Exportação concluída. Download iniciado");
  };

  const payThisTicket = async () => {
    if (allTickets.length === 0) return;

    Promise.all(
      allTickets?.map?.((item: any) =>
        api(token).put(`ticket/assemble/${item.id}`, {
          status: "ASSEMBLE_FINALIZED",
        })
      )
    )
      .then(() => {
        toast.success("Pagamentos efetuados com sucesso!");
        setIsModalOpen(false);
        refetch();
        boardRefetch();
      })
      .catch((error) => {
        toast.error("Ocorreu um erro ao aprovar os tickets");
      });
  };

  const handleSearchByPeriod = async () => {
    try {
      if (period.initial && !period.final)
        return toast.error(
          "Ao selecionar a data de Inicio, é necessário selecionar a data Final"
        );
      if (period.final && !period.initial)
        return toast.error(
          "Ao selecionar a data de Final, é necessário selecionar a data Inicial"
        );

      setLoading(true);
      const response = await api(token).get(
        `tickets/assemble/?ownerId=${
          ticket?.owner.id
        }&status=ASSEMBLE_APPROVED&forPayment=1&pageSize=10000${
          period.initial && period.final
            ? `&startDate=${period.initial}&endDate=${period.final}`
            : ""
        }`
      );
      setAllTickets(response.tickets);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onSelectChange = (value: any) => {
    setPaymentMethod(value);
    if (value === "individual") {
      setAllTickets([ticket]);
    }
  };

  const refetchAdditions = useCallback(() => {
    Promise.all(
      allTickets?.map?.((ticket: any) => {
        return api(token)
          .get(`payment/additions?fieldReportId=${ticket.id}`)
          .then((response) => {
            setAdditionals((prev) => ({ ...prev, [ticket.id]: response }));
          });
      })
    ).finally(() => setLoading(false));
  }, [token, allTickets]);

  useEffect(() => {
    setLoading(true);
    refetchAdditions();
  }, [refetchAdditions]);

  const handleDateChange = (e: Dayjs, type: "initial" | "final") => {
    if (type === "initial" && period.final && e?.isAfter(dayjs(period.final)))
      return toast.error("A data Inicial não pode ser maior que a data final");
    if (
      type === "final" &&
      period.initial &&
      e?.isBefore(dayjs(period.initial))
    )
      return toast.error("A data Final não pode ser menor que a data final");
    setPeriod((prev) => ({
      ...prev,
      [type]: e ? format(e.toDate(), "yyyy-MM-dd") : undefined,
    }));
  };

  const handleOnClose = () => {
    setPeriod({ final: undefined, initial: undefined });
    setAllTickets([]);
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        width={1000}
        title={`Pagamento - ${ticket?.owner?.fullName}`}
        open={isModalOpen}
        footer={null}
        onCancel={handleOnClose}
        style={{ overflowY: "auto" }}
      >
        <div className="flex flex-col gap-4 py-2">
          <div className="flex gap-4">
            <div className="flex flex-col">
              <b>Forma de Pagamento</b>
              <Select
                value={paymentMethod}
                className="w-32"
                onChange={onSelectChange}
              >
                <Select.Option value="individual">Individual</Select.Option>
                <Select.Option value="mass">Em Massa</Select.Option>
              </Select>
            </div>
            {paymentMethod === "mass" && (
              <>
                <div className="flex flex-col">
                  <b>Data inicial:</b>
                  <DatePicker
                    format="DD/MM/YY"
                    value={period.initial ? dayjs(period.initial) : undefined}
                    onChange={(e) => handleDateChange(e, "initial")}
                  />
                </div>
                <div className="flex flex-col">
                  <b>Data final:</b>
                  <DatePicker
                    format="DD/MM/YY"
                    value={period.final ? dayjs(period.final) : undefined}
                    onChange={(e) => handleDateChange(e, "final")}
                  />
                </div>
                <div className="flex items-end">
                  <Button onClick={handleSearchByPeriod}>Buscar Tickets</Button>
                </div>
              </>
            )}
          </div>

          <div className="flex flex-col">
            <Collapse
              style={{ color: "black" }}
              items={allTickets?.map?.((ticket: any) => ({
                key: ticket.id,
                label: `${truncateString(
                  ticket.title,
                  65
                )} -  Total: R$ ${getTotalValue(ticket.id).toFixed(2)} - ${
                  ticket.EventsAssemble?.[0]?.start
                    ? `${format(
                        new Date(ticket.EventsAssemble?.[0]?.start),
                        "dd/MM/yyyy"
                      )}`
                    : "N/A"
                }`,
                children: (
                  <>
                    <Collapse
                      ghost
                      items={[
                        {
                          key: "1",
                          label: "Produtos",
                          children: (
                            <Table
                              bordered
                              dataSource={ticket.products.map((p: any) => ({
                                ...p,
                                ...p.product,
                              }))}
                              rowKey="id"
                              pagination={false}
                            >
                              <Table.Column
                                title="Descrição"
                                dataIndex="description"
                                key="description"
                              />
                              <Table.Column
                                title="Quantidade"
                                dataIndex="quantity"
                                key="quantity"
                              />
                              <Table.Column
                                title="Senioridade"
                                dataIndex={["seniority", "name"]}
                                key="seniority"
                              />
                              <Table.Column
                                title="Tempo de Montagem"
                                dataIndex={"assemblyTime"}
                                render={(value) => `${value || 0} Horas`}
                                key="assemblyTime"
                              />
                              <Table.Column
                                title="Valor Da Montagem"
                                dataIndex={"value"}
                                render={(value) =>
                                  `R$ ${(value || 0).toFixed(2)}`
                                }
                                key="value"
                              />
                            </Table>
                          ),
                        },
                      ]}
                    />

                    <AddonsForm
                      ticketAdditions={additionals[ticket.id]}
                      ticketId={ticket.id}
                      refetch={onAddonCreationRefetch}
                    />
                    <div className="flex  text-md mt-6 justify-center font-bold "></div>
                  </>
                ),
              }))}
            />

            <div className="flex flex-col gap-10">
              <div className="flex mt-5 text-lg justify-center font-bold ">
                Total Geral: R$ {getTotalValue().toFixed(2)}
              </div>
              <div className="flex justify-between">
                <Button onClick={handleOnClose}>Cancelar</Button>
                <Button onClick={exportXls} type="primary">
                  Gerar Documento
                </Button>
                <Button type="primary" onClick={payThisTicket}>
                  Aprovar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Button
        size="small"
        disabled={
          !hasMinimumPermissions("payments", user) ||
          !!ticket?.PaymentAdditions?.filter(
            (item) =>
              item.status === PaymentAdditionStatusEnum.PENDING_APPROVEMENT
          )?.length
        }
        onClick={() => setIsModalOpen(true)}
      >
        Aprovar o Pagamento
      </Button>
    </>
  );
};
